export const createImageUrl = (imageId: string | null | undefined): string => {
    if (!imageId) return '';
    if (typeof imageId === 'string' && imageId.startsWith('http')) return imageId;
    return imageId;
};
